import React from "react";

const InternationalBidsFilter = (props) => {
    const setValue = (e) => {
        const value = e.target.value;
        switch (value) {
            case "withoutInternationalBids": {
                props.setFilter({ name: "withInternationalBids", value: false });
                props.setFilter({ name: "withoutInternationalBids", value: true });
                break;
            }
            case "withInternationalBids": {
                props.setFilter({ name: "withInternationalBids", value: true });
                props.setFilter({ name: "withoutInternationalBids", value: false });
                break;
            }
            default: {
                props.setFilter({ name: "withInternationalBids", value: false });
                props.setFilter({ name: "withoutInternationalBids", value: false });
                break;
            }
        }
    };
    const value = props.values.withoutInternationalBids
        ? "withoutInternationalBids"
        : props.values.withInternationalBids
          ? "withInternationalBids"
          : "";
    return (
        <div className="mb-md-0 report__filters--mr">
            <select className="form-control form-control-sm" onChange={setValue} value={value}>
                <option value="">Все</option>
                <option value="withInternationalBids">Международные</option>
                <option value="withoutInternationalBids">Без международных</option>
            </select>
        </div>
    );
};

export default InternationalBidsFilter;
